<template>
  <div >
    <div :class="snackbarClass" :style="{ minWidth:minwidth+'%',  top:topalign+'px', backgroundColor:backgroundColor, right:rightalign,  left:leftalign+'%' }"> {{ message }} </div>

  </div>
</template>
            
<script>
export default {
    props:['message', 'backgroundColor', 'leftalign', 'minwidth', "rightalign", "topalign", "snackbarClass"],
    created(){
      console.log("snackbar ",this.topalign)
    }
      
};
</script>


<style scoped>
.snackbar {
  min-width: 85%;
  background-color: #333;
  color: #fff;
  text-align: center;
  border-radius: 2px;
  padding: 10px;
  position: fixed;
  z-index: 99999;
  font-size: 15px;
  -webkit-animation: fadein 0.5s, fadeout 0.5s 3.8s;
  animation: fadein 0.5s, fadeout 0.5s 3.8s;
}
@-webkit-keyframes fadein {
  from {top: 0; opacity: 0;} 
  to {top: 40px; opacity: 1;}
}

@keyframes fadein {
  from {top: 0; opacity: 0;}
  to {top: 40px; opacity: 1;}
}

@-webkit-keyframes fadeout {
  from {top: 40px; opacity: 1;} 
  to {top: 0; opacity: 0;}
}

@keyframes fadeout {
  from {top: 40px; opacity: 1;}
  to {top: 0; opacity: 0;}
}

.login-snackbar {
  min-width: 85%;
  background-color: #333;
  color: #fff;
  text-align: center;
  border-radius: 2px;
  padding: 10px;
  position: fixed;
  z-index: 9999;
  font-size: 15px;
  -webkit-animation: fadeinlogin 0.5s, fadeoutlogin 0.5s 2.8s;
  animation: fadeinlogin 0.5s, fadeoutlogin 0.5s 2.8s;
}
@-webkit-keyframes fadeinlogin {
  from {top: -40px; opacity: 0;} 
  to {top: 0px; opacity: 1;}
}

@keyframes fadeinlogin {
  from {top: -40px; opacity: 0;}
  to {top: 0; opacity: 1;}
}

@-webkit-keyframes fadeoutlogin {
  from {top: 0; opacity: 1;} 
  to {top: -40px; opacity: 0;}
}

@keyframes fadeoutlogin {
  from {top: 0; opacity: 1;}
  to {top: -40px; opacity: 0;}
}
</style>


// WEBPACK FOOTER //
// src/Snackbar.vue